/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root.tsx'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe.tsx'
import { Route as RecommendationRouteRouteImport } from './routes/recommendation/route.tsx'
import { Route as IndexRouteImport } from './routes/index.tsx'
import { Route as RecommendationIndexRouteImport } from './routes/recommendation/index.tsx'
import { Route as RecommendationUnsubscribeRouteImport } from './routes/recommendation/unsubscribe.tsx'
import { Route as RecommendationThanksRouteImport } from './routes/recommendation/thanks.tsx'
import { Route as RecommendationExpiredRouteImport } from './routes/recommendation/expired.tsx'
import { Route as RecommendationConfirmRouteImport } from './routes/recommendation/confirm.tsx'
import { Route as RecommendationAppliedRouteImport } from './routes/recommendation/applied.tsx'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const RecommendationRouteRoute = RecommendationRouteRouteImport.update({
  id: '/recommendation',
  path: '/recommendation',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecommendationIndexRoute = RecommendationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RecommendationRouteRoute,
} as any)
const RecommendationUnsubscribeRoute =
  RecommendationUnsubscribeRouteImport.update({
    id: '/unsubscribe',
    path: '/unsubscribe',
    getParentRoute: () => RecommendationRouteRoute,
  } as any)
const RecommendationThanksRoute = RecommendationThanksRouteImport.update({
  id: '/thanks',
  path: '/thanks',
  getParentRoute: () => RecommendationRouteRoute,
} as any)
const RecommendationExpiredRoute = RecommendationExpiredRouteImport.update({
  id: '/expired',
  path: '/expired',
  getParentRoute: () => RecommendationRouteRoute,
} as any)
const RecommendationConfirmRoute = RecommendationConfirmRouteImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => RecommendationRouteRoute,
} as any)
const RecommendationAppliedRoute = RecommendationAppliedRouteImport.update({
  id: '/applied',
  path: '/applied',
  getParentRoute: () => RecommendationRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/recommendation': typeof RecommendationRouteRouteWithChildren
  '/unsubscribe': typeof UnsubscribeRoute
  '/recommendation/applied': typeof RecommendationAppliedRoute
  '/recommendation/confirm': typeof RecommendationConfirmRoute
  '/recommendation/expired': typeof RecommendationExpiredRoute
  '/recommendation/thanks': typeof RecommendationThanksRoute
  '/recommendation/unsubscribe': typeof RecommendationUnsubscribeRoute
  '/recommendation/': typeof RecommendationIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/recommendation/applied': typeof RecommendationAppliedRoute
  '/recommendation/confirm': typeof RecommendationConfirmRoute
  '/recommendation/expired': typeof RecommendationExpiredRoute
  '/recommendation/thanks': typeof RecommendationThanksRoute
  '/recommendation/unsubscribe': typeof RecommendationUnsubscribeRoute
  '/recommendation': typeof RecommendationIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/recommendation': typeof RecommendationRouteRouteWithChildren
  '/unsubscribe': typeof UnsubscribeRoute
  '/recommendation/applied': typeof RecommendationAppliedRoute
  '/recommendation/confirm': typeof RecommendationConfirmRoute
  '/recommendation/expired': typeof RecommendationExpiredRoute
  '/recommendation/thanks': typeof RecommendationThanksRoute
  '/recommendation/unsubscribe': typeof RecommendationUnsubscribeRoute
  '/recommendation/': typeof RecommendationIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/recommendation'
    | '/unsubscribe'
    | '/recommendation/applied'
    | '/recommendation/confirm'
    | '/recommendation/expired'
    | '/recommendation/thanks'
    | '/recommendation/unsubscribe'
    | '/recommendation/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/unsubscribe'
    | '/recommendation/applied'
    | '/recommendation/confirm'
    | '/recommendation/expired'
    | '/recommendation/thanks'
    | '/recommendation/unsubscribe'
    | '/recommendation'
  id:
    | '__root__'
    | '/'
    | '/recommendation'
    | '/unsubscribe'
    | '/recommendation/applied'
    | '/recommendation/confirm'
    | '/recommendation/expired'
    | '/recommendation/thanks'
    | '/recommendation/unsubscribe'
    | '/recommendation/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  RecommendationRouteRoute: typeof RecommendationRouteRouteWithChildren
  UnsubscribeRoute: typeof UnsubscribeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recommendation': {
      id: '/recommendation'
      path: '/recommendation'
      fullPath: '/recommendation'
      preLoaderRoute: typeof RecommendationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recommendation/': {
      id: '/recommendation/'
      path: '/'
      fullPath: '/recommendation/'
      preLoaderRoute: typeof RecommendationIndexRouteImport
      parentRoute: typeof RecommendationRouteRoute
    }
    '/recommendation/unsubscribe': {
      id: '/recommendation/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/recommendation/unsubscribe'
      preLoaderRoute: typeof RecommendationUnsubscribeRouteImport
      parentRoute: typeof RecommendationRouteRoute
    }
    '/recommendation/thanks': {
      id: '/recommendation/thanks'
      path: '/thanks'
      fullPath: '/recommendation/thanks'
      preLoaderRoute: typeof RecommendationThanksRouteImport
      parentRoute: typeof RecommendationRouteRoute
    }
    '/recommendation/expired': {
      id: '/recommendation/expired'
      path: '/expired'
      fullPath: '/recommendation/expired'
      preLoaderRoute: typeof RecommendationExpiredRouteImport
      parentRoute: typeof RecommendationRouteRoute
    }
    '/recommendation/confirm': {
      id: '/recommendation/confirm'
      path: '/confirm'
      fullPath: '/recommendation/confirm'
      preLoaderRoute: typeof RecommendationConfirmRouteImport
      parentRoute: typeof RecommendationRouteRoute
    }
    '/recommendation/applied': {
      id: '/recommendation/applied'
      path: '/applied'
      fullPath: '/recommendation/applied'
      preLoaderRoute: typeof RecommendationAppliedRouteImport
      parentRoute: typeof RecommendationRouteRoute
    }
  }
}

interface RecommendationRouteRouteChildren {
  RecommendationAppliedRoute: typeof RecommendationAppliedRoute
  RecommendationConfirmRoute: typeof RecommendationConfirmRoute
  RecommendationExpiredRoute: typeof RecommendationExpiredRoute
  RecommendationThanksRoute: typeof RecommendationThanksRoute
  RecommendationUnsubscribeRoute: typeof RecommendationUnsubscribeRoute
  RecommendationIndexRoute: typeof RecommendationIndexRoute
}

const RecommendationRouteRouteChildren: RecommendationRouteRouteChildren = {
  RecommendationAppliedRoute: RecommendationAppliedRoute,
  RecommendationConfirmRoute: RecommendationConfirmRoute,
  RecommendationExpiredRoute: RecommendationExpiredRoute,
  RecommendationThanksRoute: RecommendationThanksRoute,
  RecommendationUnsubscribeRoute: RecommendationUnsubscribeRoute,
  RecommendationIndexRoute: RecommendationIndexRoute,
}

const RecommendationRouteRouteWithChildren =
  RecommendationRouteRoute._addFileChildren(RecommendationRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  RecommendationRouteRoute: RecommendationRouteRouteWithChildren,
  UnsubscribeRoute: UnsubscribeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
